import type { InterestedInInvestingProps } from "@/types";
import { ContentManager } from "../content-manager";
import NextImage from "next/image";
import type { FC } from "react";

export const InterestedInInvesting: FC<InterestedInInvestingProps> = ({content}) => {
  const handleClick = () => {};
	return  (
		<section className="interestedInInvesting">
			<div className="wrapper wrapper_lg">
				<div className="cta originatingInstitutionsHero--cta">
          <div className="cta--inner">
            {content.text && (
              <ContentManager content={content.text} className="cta--text" />
            )}
            <button
              className="link link_white link_full cta--link"
              onClick={() => {
                handleClick();
              }}
              data-title={content.buttonLabel}
            >
              <span>{content.buttonLabel}</span>
            </button>
          </div>
          <NextImage
            src="/images/spiral-2.webp"
            alt="Spiral"
            width={1417}
            height={1653}
            role="presentation"
            draggable={false}
            className="cta--spiral"
          />
        </div>
			</div>
		</section>
  )
}